import { ReportingServerData } from "@sportal/api";

import {
  LOAD_SETTINGS,
  GET_SETTINGS_FAILURE,
  GET_SETTINGS_SUCCESS,
  SettingsActionTypes,
  SettingsSuccessPayload,
} from "./settings.types";
import { withLoadingState } from "../shared";

export type SettingsState = SettingsSuccessPayload;

const initialState: SettingsState = {
  services: [],
  reporting: {} as ReportingServerData,
};

const reducer = (
  state: SettingsState = initialState,
  action: SettingsActionTypes
): SettingsState => {
  switch (action.type) {
    case GET_SETTINGS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default withLoadingState({
  loadActionType: LOAD_SETTINGS,
  successActionType: GET_SETTINGS_SUCCESS,
  failureActionType: GET_SETTINGS_FAILURE,
})(reducer);
